import { render, staticRenderFns } from "./DispensingPermitted.vue?vue&type=template&id=0199f37e"
import script from "./DispensingPermitted.vue?vue&type=script&lang=js"
export * from "./DispensingPermitted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports